module.exports = __webpack_public_path__ + "static/media/lp-left.b343e5a7.jpg";